import "./contractDropdown.css";
import Checkbox from "../../../../components/Checkbox/Checkbox";
import TextButton from "../../../../components/Buttons/TextButton/TextButton";
// import CloseButton from "../../../../components/Buttons/CloseButton/closeButton";

export default function ContractDropdown({ selectedContractType, setSelectedContractType }) {
  const handleCheckboxChange = (contractType) => {
    if (selectedContractType.includes(contractType)) {
      // Om användaren klickar på ett alternativ som redan är valt - avmarkera
      setSelectedContractType(selectedContractType.filter((item) => item !== contractType));
    } else {
      // Om användaren klickar på ett nytt alternativ - ersätt med endast det värdet
      setSelectedContractType([contractType]);
    }
  };

  const handleClearButtonClick = () => {
    setSelectedContractType([]);
    sessionStorage.removeItem("selectedContractType");
  };

  return (
    <div className={`contract-dropdown`}>
      <div className="contract-dropdown-header">
        <p>Kontraktstyp</p>
        <TextButton label="Rensa" size={"xxs"} onClick={handleClearButtonClick} />
        {/* <CloseButton onClick={closeContractDropdown} /> */}
      </div>
      <div className="contracts-content-wrapper">
        <div className="contracts-checkbox-wrapper">
          <Checkbox
            label="Förstahandskontrakt"
            isChecked={selectedContractType.includes("Förstahandskontrakt")}
            onChange={() => handleCheckboxChange("Förstahandskontrakt")}
          />
          <Checkbox
            label="Andrahandskontrakt"
            isChecked={selectedContractType.includes("Andrahandskontrakt")}
            onChange={() => handleCheckboxChange("Andrahandskontrakt")}
          />
        </div>
      </div>
      <hr />
      <div className="contracts-button-wrapper">
        {/* <TextButton label="Rensa" onClick={handleClearButtonClick} /> */}
      </div>
    </div>
  );
}
